module.exports = "/images/body-fluid-borne-disease@3x.png?cc7eebf20e56bf537ece7114fe66e42c";